// ── ReportClaudePanel (Evo Brain — panel 4) ──────────────────────────────────
// Ya no renderiza UI propia — el shell genérico vive en AssistantDock (ver
// contexts/AssistantContext.tsx). Esto solo registra la entidad activa.

import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';
import { useReport } from '../../hooks/useReports.js';

interface Props {
  reportId: number | null;
}

export function ReportClaudePanel({ reportId }: Props) {
  const { t } = useTranslation();
  const { data: report } = useReport(reportId);

  useAssistantModule('report', reportId != null ? String(reportId) : null, undefined);

  useRegisterAssistantActive('report', reportId != null ? String(reportId) : null, {
    title: t('reports.assistant.title'),
    placeholder: reportId ? t('reports.assistant.placeholder') : t('reports.assistant.placeholderDisabled'),
    inputDisabled: !reportId,
    emptyHint: t('reports.assistant.empty'),
    entityLink: report ? { label: report.title, href: `/reports/${report.id}` } : null,
  });

  return null;
}
